export function getAvailableLuxPlusInclusionsForMembers(
  luxPlusInclusionsByTier: App.LuxPlusInclusionsByTier | undefined,
  inclusionsViewableLuxPlusTier: App.MembershipSubscriptionTier,
  hasLuxPlusOrSubscriptionInCart: boolean,
): Array<App.PackageInclusion> {
  if (!hasLuxPlusOrSubscriptionInCart || !luxPlusInclusionsByTier) {
    return []
  }

  return luxPlusInclusionsByTier[inclusionsViewableLuxPlusTier] || []
}

export function buildAllStandardInclusions(
  standardInclusions: Array<App.PackageInclusion>,
  tileInclusions: Array<App.OfferInclusion> | undefined,
  shouldHighlightInclusion: boolean = true,
): Array<App.PackageInclusion> {
  const flashOfferInclusions = tileInclusions || []

  return [
    ...standardInclusions,
    ...flashOfferInclusions,
  ].map((inclusion, index) => {
    const isHighlighted = shouldHighlightInclusion ? (index === 0 || inclusion.isHighlighted) : false

    const symbol = inclusion.symbol || (isHighlighted ? 'tag' : undefined)
    return {
      ...inclusion,
      symbol,
      isHighlighted,
    }
  }) as Array<App.PackageInclusion>
}
